import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaYoutube, FaLinkedin, FaMapMarkerAlt } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">HOME</Link></li>
              <li><Link to="/about">ABOUT</Link></li>
              <li><Link to="/products">PRODUCTS</Link></li>
              <li><Link to="/contact">CONTACT</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="footer-social">
              <a href="https://www.facebook.com/share/17LarQdQkZ/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://www.youtube.com/@newtonsarkar8635" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
              <a href="https://www.linkedin.com/in/newton-sarkar-9a7828374" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Address</h3>
            <div className="footer-address">
              <FaMapMarkerAlt className="address-icon" />
              <span>Domkal, Murshidabad, West Bengal</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2025 SARKAR TRADERS. — All Rights Reserved. — Developed by Muktarul Hossain</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

